<template>
  <aside class="" >
    <div class="menu">
      <!-- группа создание -->
      <template v-if="actionPermFilter.add && actionPermFilter.add.length > 0">
        <ul class="menu-list">
          <li v-accordeon="submenu.create">
            <a href="#" @click.prevent="submenu.create = !submenu.create" class="menu-list-opener">
              <span class="icon mr-1 has-text-grey"><i :class="`fas fa-plus`"></i></span>
              Создать
            </a>
            <ul class="menu-list">
              <li v-for="(item, id) in actionPermFilter.add" :key="id">
                <router-link :to="`/dashboard/${item.app}/${item.model}/create`" exact>{{ $tc(item.model) }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </template>

      <!-- группа подпись -->
      <template v-if="actionPermFilter.sign && actionPermFilter.sign.length > 0">
        <ul class="menu-list">
          <li v-accordeon="submenu.sign">
            <a href="#" @click.prevent="submenu.sign = !submenu.sign" class="menu-list-opener">
              <span class="icon mr-1 has-text-grey"><i :class="`fas fa-signature`"></i></span>
              Подпись
            </a>
            <ul class="menu-list">
              <li v-for="(item, id) in actionPermFilter.sign" :key="id">
                <router-link :to="`/dashboard/${item.app}/${item.model}?signed=0`" exact>{{ $tc(item.model) }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </template>

      <!-- группа просмотр -->
      <template v-if="actionPermFilter.view && actionPermFilter.view.length > 0">
        <ul class="menu-list">
          <li v-accordeon="submenu.view">
            <a href="#" @click.prevent="submenu.view = !submenu.view" class="menu-list-opener">
              <span class="icon mr-1 has-text-grey"><i :class="`fas fa-briefcase`"></i></span>
              Просмотр
            </a>
            <ul class="menu-list">
              <li v-for="(item, id) in actionPermFilter.add" :key="id">
                <router-link :to="`/dashboard/${item.app}/${item.model}`" exact>{{ $tc(item.model) }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </template>

      <!-- группа авторизация -->
      <template v-if="!('id' in me)">
        <p class="menu-label m-0 py-3 px-3" >Авторизация</p>
        <ul class="menu-list" @click="closeMenuIfMobile">
          <li>
            <router-link v-slot="{ href, navigate, isActive, isExactActive }" :to="'/login'" title="Страница авторизации">
              <a :href="href" @click="navigate" :class="[isActive && 'is-active', isExactActive && 'router-link-exact-active']">
                <span class="icon " :class="isActive || isExactActive ? 'has-text-white' : 'has-text-primary'"><i class="fas fa-sign-in-alt "></i></span>
                Вход
              </a>
            </router-link>
          </li>
        </ul>
      </template>
      <template v-else>
        <p class="menu-label my-3 px-3" ><strong>Профиль</strong></p>
        <ul class="menu-list" @click="closeMenuIfMobile">
          <li>
            <!-- <router-link v-slot="{ href, route, navigate, isActive, isExactActive }" to="/me" title="открыть профиль">
              <a :href="href" @click="navigate" :class="[isActive && 'is-active', isExactActive && 'router-link-exact-active']">
                <span class="icon " :class="isActive || isExactActive ? 'has-text-white' : 'has-text-success'"><i class="fas fa-user "></i></span>
                {{me.email}}
              </a>
            </router-link> -->
            <router-link to="/me" title="открыть профиль">
              <span class="icon has-text-success"><i class="fas fa-user "></i></span>
              {{me.email}}
            </router-link>
          </li>
          <li>
            <router-link v-slot="{ href, navigate, isActive, isExactActive }" to="/login" title="сменить профиль">
              <a :href="href" @click="navigate" :class="[isActive && 'is-active', isExactActive && 'router-link-exact-active']">
                <span class="icon " :class="isActive || isExactActive ? 'has-text-white' : 'has-text-info'"><i class="fas fa-exchange-alt "></i></span>
                {{$store.state.user.appointment.profession && $store.state.user.appointment.profession.title || 'Должность не назначена'}}
                {{$store.state.user.appointment.profession ? ' - ' : ''}}
                {{$store.state.user.appointment.profession && $store.state.user.appointment.organization.name || ''}}
              </a>
            </router-link>
          </li>
          <li>
            <a @click.prevent="logout">
              <span class="icon has-text-danger"><i class="fas fa-sign-out-alt "></i></span>
              Выйти
            </a>
          </li>
        </ul>
      </template>
    </div>
  </aside>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import common from '@/mixins/common'

export default {
  mixins: [common],
  props: {
    showDrawer: Boolean
  },
  data () {
    return {
      submenu: {
        create: false,
        sign: false,
        view: false
      }
    }
  },
  computed: {
    ...mapState('user', ['me', 'appointment']),
    ...mapGetters('user', ['actionPermFilter']),
    pageLinks () {
      return this.$store.state.drawerLinks
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
      if (this.$route.path !== '/') this.$router.push('/')
    },
    closeMenuIfMobile () {
      if (window.innerWidth < 1024) this.$emit('clicked')
    },
    permsToArray () {
      const permArray = []
      const perms = this.$store.state.user.permissions
      for (const app in perms) {
        for (const model in perms[app]) {
          permArray.push(`${app}.${model}.${perms[app][model]}`)
        }
      }
      return permArray
    }
  }
}
</script>
<style lang="scss">
  @import '@/css/variables.scss';

  .menu-list-opener {
    display: flex!important;
    align-items: center;
  }
  .menu-list-opener::after {
    content: '\f107';
    margin-left: auto;
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    transition: all .2s;
  }
  .menu-list>.open>.menu-list-opener:not(.is-active) {
    background-color: rgba($color: white, $alpha: .5);
  }
  .menu-list>.open>.menu-list-opener::after {
    transform: rotateZ(180deg);
  }
  .menu-list a.is-active:not(.router-link-exact-active) {
    background-color: rgba($color: white, $alpha: .5);
    color: inherit;
  }
  .menu-list a.is-active .icon {
    color: inherit!important;
  }
  .menu-list a.is-active:not(.router-link-exact-active) .icon {
    color: $grey!important;
  }
</style>
